<template>
  <vs-popup title="동국제강 기본 안전보건수칙" :active.sync="show" id="popup-안전보건수칙">
    <span v-text="content" style="white-space: pre-wrap;" />
    <div class="mt-4" style="border-top: solid 1px #cdcdcd; justify-items: center;">
      <vs-checkbox class="m-4" v-model="localCheck" @input="show = false">
        기본안전수칙을 확인하였으며, 해당 안전수칙을 필히 이행함에 동의함.
      </vs-checkbox>
      <div class="mb-2">동국제강</div>
    </div>

  </vs-popup>
</template>

<script>
export default {
  props: {
    value: Boolean,
    check: Boolean,
  },
  data() {
    return {
      show: this.value,
      localCheck: this.check,
      content: `1. 작업 전 실시사항(공사 당일 ~ )
        가.당사 출입 : 출입관리시스템(작업자 출입관리)를 통한 출입
        나.안전교육 실시
        다.유해ㆍ위험기계기구 확인
        라.공사현황판 설치 : 개요, 안전대책, 위험성평가, 일일안전작업허가서
        마.TBM(Tool Box Meeting) 실시 : 안전보호구 및 지급대장 확인 포함
        바.변경 인원 발생시 즉시 통보

        2. 작업 중 실시사항
        가.ILS 또는 LOTO(위험차단시스템) 이행철저, 다자간 시건 실시
        나.고소작업
        (1) 안전대(전체식) 착용 및 안전고리 체결 : 부착설비 확인 및 설치
      (2) 개구부, 발판, 난간대 등 방호장치 설치
      (3) 옥외 작업 시 기상상태 확인
      (4) 상ㆍ하 동시작업 불가
      (5) 고소작업 구역 설정
        다.전기차단작업
        (1) 타 부서 및 주변 작업자에 사전 통보
      (2) 주전원 차단
      (3) 차단표지판 부착
        라.밀폐공간 작업
      (1) 가스농도측정 : 최초 / 휴식 후 재투입 시(단, 밀폐공간내 가스농도측정기 항시비치)
        (2) 비상용 구출장비 구비
      (3) 밀폐공간에 맞는 보호구 구비(송기마스크 또는 공기호흡기)
        (4) 충분한 환기장치 설치
      (5) 밀폐공간 입 / 출 확인 철저(출입관리대장 작성)
        (6) 감독자 배치
        마.중장비(지게차, 이동식 크레인 등) 작업시 신호수 별도배치 및 하부작업자 접근통제
      (1) 신호수 배치
      (2) 작업 주변 통제
        바.사다리 사용 시 법적 범위내 실시 : 아웃트리거 필히 설치
      (1) 1.2m미만 : 안전모 착용 후 작업 실시
      (2) 1.2m이상 ~2m미만 : 안전모 착용, 2인1조 작업, 최상부 발판에서 작업 금지
      (3) 2m이상 ~3.5m미만 : 안전모 착용, 2인1조 작업 및 안전대 착용, 최상부 발판 및 그 하단 디딤대 작업금지
      (4) 3.5m 초과 : 작업발판으로 사용금지(작업 금지)
        사.화기작업
        (1) 용접기 상태 확인 : 전격방지기, 용접기홀더, 전원피복상태 등
      (2) 화재감시자 배치(건설업 기초건설안전보건교육 이수자)
        -작업반경 11미터 이내에 건물구조 자체나 내부에 가연성물질이 있는 장소
      - 작업반경 11미터 이내의 바닥 하부에 가연성물질이 11미터 이상 떨어져 있지만 불꽃에 의해 쉽게
        발화될 우려가 있는 장소
      (3) 소화기 비치, 불티방지포 설치
      (4) 화기작업 장소 복합가스 측정
        아.작업장 관리감독

        3. 작업 후 실시사항 정리정돈 및 사내환경기준 준수
        가.주변 정리정돈
        나.폐기물 분리 및 지정장소 배출
        다.발주처(동국)관리감독자 최종확인`
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        this.show = value;
      },
    },
    show: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    check: {
      immediate: true,
      deep: true,
      handler(value) {
        this.localCheck = value;
      },
    },
    localCheck: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("update:check", value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
#popup-안전보건수칙::v-deep {
  .vs-popup {
    max-width: 1095px;
    width: 96%;
  }
}

.title {
  border-left: 8px solid #002452;
  padding-left: 12px;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
}
th,
td {
  border: 1px solid #a0a5ab;
  padding: 8px 2px;
  text-align: center;
}
th {
  color: #002452;
  font-size: 14px;
  background-color: #d8e0e8;
  padding: 12px 2px;
}

.table-2 td {
  color: #002452;
}
.highlight {
  text-decoration: underline;
  background-color: #fbf1e2;
}
</style>
